var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.627 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    transform: "matrix(.26458 0 0 .26458 -22.586 -40.217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.864 158.791v13.838c0 1.863-1.557 3.371-3.474 3.371H90.61c-1.923 0-3.474-1.508-3.474-3.371v-13.838zM106.509 154.833v.914q0 .212-.082.407a1.074 1.074 0 0 1-.985.656H86.555a1.05 1.05 0 0 1-.752-.311 1.06 1.06 0 0 1-.312-.752v-.914a1.066 1.066 0 0 1 1.064-1.068h3.809a1.76 1.76 0 0 1 1.089-1.632c.214-.089.444-.134.676-.133h7.738a1.76 1.76 0 0 1 1.631 1.09c.089.214.135.443.135.675h3.808a1.069 1.069 0 0 1 1.068 1.068z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f81277887e193f31f1019afc75ef3ae9.svg";
export { ForwardRef as ReactComponent };